import {sanitizeDisplayHtml} from '../../../utils/safe-html';

export function HtmlField({ field }: any) {
  const config = field.config;
  return <div dangerouslySetInnerHTML={{ __html: sanitizeDisplayHtml(config.htmlContent || config.label) }} />;
}
